import { Box, Tooltip } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { aiAssistantContext } from '../../../state/AIAssistantContextProvider';
import AIButton from '../../AIButton';
import { useReaderContext } from '../../Reader/ReaderContext';

interface AIAssistantTogglerProps {
	isClassic?: boolean;
	buttonType?: 'round' | 'rectangular';
}

const AIAssistantToggler = ({
	isClassic = false,
	buttonType = 'round',
}: AIAssistantTogglerProps) => {
	const { t } = useTranslation();
	const { isAssistantDisabled, isAssistantOpen, openAssistant, closeAssistant } =
		useContext(aiAssistantContext);
	const { mindItemId } = useReaderContext();

	const handleTogglerClick = () => {
		if (isAssistantOpen) {
			closeAssistant();
		} else {
			openAssistant(mindItemId);
		}
	};

	const tooltipTitle = isAssistantDisabled
		? t('AI assistant temporarily unavailable')
		: t('AI Assistant Muki');
	const tooltipPlacement = buttonType === 'round' ? 'left' : 'bottom';

	return (
		<Tooltip title={tooltipTitle} placement={tooltipPlacement} arrow>
			<Box sx={{ flexShrink: 0 }}>
				<AIButton
					isClassic={isClassic}
					isActive={isAssistantOpen}
					onClick={handleTogglerClick}
					disabled={isAssistantDisabled}
					buttonType={buttonType}
				/>
			</Box>
		</Tooltip>
	);
};

export default AIAssistantToggler;
